 import IndexedDbWrapper from "../../core/wrappers/browserStorage/indexedDb-wrapper";

export  const getParams = (type:string,val:any ) => {
  let params: any = {};
  if (type==="orderNumber") params.orderNumber=val;
  else if (type==="shippingNumber") params.shippingListNo=val;
  else params=val;
  return params;
};

export async function deleteRequests(id:number) {
  IndexedDbWrapper.deleteItemFromDb("orderRequests", id);
  getRequests();

}
export const addToCache = (type:any,val:any) =>  { IndexedDbWrapper.addItemToDb("orderRequests", val,type); }

export async function getRequests() {
  let val:any;
  await IndexedDbWrapper.getAllItemFromDb("orderRequests")
    .then((result) => {
      val=result;
    })
    .catch((error) => {
      console.log(error);
      val= null;
    });
    console.info(val);
    return val;
}

export const initialState = {
  cargoFilters:{
    status: null,
    cargoCompany: null,
    deliveryType: null,
    shoppingAmount: null,
    shipmentFee: null,    
    region: -1
   },
   updatedShippingFee:{
    id:0,
    shoppingAmount: '',
    shipmentFee: '',
    condition:'' 
   }
  }
export class CargoFilter {  
  status?: number;
  cargoCompany?: number;
  deliveryType?: number;
  shoppingAmount?: number;
  shipmentFee?: number;
  region?: number;

    constructor(status:number,cargoCompany:number,deliveryTpe:number,shoppingAmount: number, shipmentFee: number,region: number) {               
              this.status=status
              this.cargoCompany=cargoCompany
              this.deliveryType=deliveryTpe
              this.shoppingAmount=shoppingAmount
              this.shipmentFee=shipmentFee              
              this.region=region
           }  
}

export class CargoShipmentFeeManagement extends CargoFilter  {
  id:number;
  condition:string;

  constructor(id:number,status:number,cargoCompany:number,deliveryTpe:number,shoppingAmount: number, shipmentFee: number,region: number,condition: string) {       
           super(status,cargoCompany,deliveryTpe,shoppingAmount,shipmentFee,region);
           this.id=id;
           this.condition=condition;
        }  
}



 